import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import { faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { SortOrder } from '../../../types/sort/sort';

interface SortIconProps {
  sortOrder: SortOrder;
  sortColumn: string;
  activeSortColumn: string;
  onClick: (sortColumn: string) => void;
}

const SortIcon = ({
  sortOrder,
  sortColumn,
  activeSortColumn,
  onClick,
}: SortIconProps) => {
  const isActive = activeSortColumn === sortColumn;
  return (
    <Button
      className="text-white"
      size="sm"
      onClick={() => onClick(sortColumn)}
      variant="link"
    >
      <div className="d-flex flex-column align-items-center">
        <FontAwesomeIcon
          icon={faCaretUp}
          style={{
            visibility: isActive && sortOrder === 'desc' ? 'hidden' : 'visible',
          }}
        />
        <FontAwesomeIcon
          icon={faCaretDown}
          style={{
            visibility: isActive && sortOrder === 'asc' ? 'hidden' : 'visible',
          }}
        />
      </div>
    </Button>
  );
};

export default SortIcon;
